module.exports = __webpack_public_path__ + "img/img_o.cdfb4bb2.png";